import { PropsWithChildren } from 'react';
import classes from './style.module.scss';

type IProps = {}

export default function Content({ children }: PropsWithChildren<IProps>) {
	return <div className={classes["content"]}>{children}</div>;
}